import React from 'react';
import { Icon24Link } from '@vkontakte/icons';
import { classNames } from '@vkontakte/vkjs';
import { SimpleCell } from '@vkontakte/vkui';
import styles from './MessageBubbleAttachLink.module.css';

interface MessageBubbleAttachLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  subtitle: string;
}

export function MessageBubbleAttachLink(props: MessageBubbleAttachLinkProps) {
  const { subtitle, onClick, className, children, ...rest } = props;

  return (
    <SimpleCell
      {...rest}
      multiline
      className={classNames(styles.root, className)}
      before={
        <div className={styles.icon}>
          <Icon24Link />
        </div>
      }
      onClick={onClick}
      hoverMode="opacity"
      activeMode="opacity"
      subtitle={<div className={styles.subtitle}>{subtitle}</div>}
    >
      {children}
    </SimpleCell>
  );
}
